export const KNOWLEDGE_BASE_URL = {
  BULK_MANAGEMENT: 'https://knowledge-base.yieldbird.com/yieldbird-platform/bulk-management',
  CUSTOM_CODE: 'https://knowledge-base.yieldbird.com/yieldbird-platform/custom-code',
  FAILSAFE_TIMEOUT: 'https://knowledge-base.yieldbird.com/yieldbird-platform/failsafe-timeout',
  PUB_ADS_SERVICE:
    'https://knowledge-base.yieldbird.com/yieldbird-platform/pubadsservicerefresh-function-control',
  TARGETING_AUCTION_TYPE:
    'https://knowledge-base.yieldbird.com/yieldbird-platform/targeting-auction-type',
} as const
